/* eslint-disable @typescript-eslint/no-explicit-any */
import { APIErrorType, InternalError } from './axiosRequest'

export const getExceptionPayload = (ex: unknown): APIErrorType => {
  if (typeof ex !== 'object' || !ex) {
    return InternalError
  }

  try {
    const typedException = ex as Record<string, any>

    // Check if the exception object has the expected structure
    if (
      typedException.error &&
      typeof typedException.error === 'object' &&
      'details' in typedException.error &&
      typeof typedException.error.details === 'string'
    ) {
      return {
        error: {
          code: typedException.error.code || '500',
          details: typedException.error.details,
        },
      }
    }

    // Handle case where error might be nested differently
    if (typedException.response?.data?.error) {
      const error = typedException.response.data.error
      return {
        error: {
          code: error.code || '500',
          details: error.details || 'Unknown error occurred',
        },
      }
    }

    // Handle case for general API error format
    if (typedException.message) {
      return {
        error: {
          code: typedException.code || '500',
          details: typedException.message,
        },
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error parsing exception:', err)
  }

  return InternalError
}
